import axios from "axios";
import {
  ADD_LEAVE_OF_USERS_FAIL,
  ADD_LEAVE_OF_USERS_REQUEST,
  ADD_LEAVE_OF_USERS_SUCCESS,
  DELETE_LEAVE_OF_USERS_FAIL,
  DELETE_LEAVE_OF_USERS_REQUEST,
  DELETE_LEAVE_OF_USERS_SUCCESS,
  GET_LEAVE_OF_USERS_BY_ID_FAIL,
  GET_LEAVE_OF_USERS_BY_ID_REQUEST,
  GET_LEAVE_OF_USERS_BY_ID_SUCCESS,
  GET_LEAVE_SETTING_FAIL,
  GET_LEAVE_SETTING_REQUEST,
  GET_LEAVE_SETTING_SUCCESS,
  GET_LEAVE_OF_COMPANY_FAIL,
  GET_LEAVE_OF_COMPANY_REQUEST,
  GET_LEAVE_OF_COMPANY_SUCCESS,
  ADD_LEAVE_OF_USERS_REJECT_FAIL,
  ADD_LEAVE_OF_USERS_REJECT_REQUEST,
  ADD_LEAVE_OF_USERS_REJECT_SUCCESS,
  ADD_LEAVE_OF_USERS_APPROVE_FAIL,
  ADD_LEAVE_OF_USERS_APPROVE_REQUEST,
  ADD_LEAVE_OF_USERS_APPROVE_SUCCESS,
} from "../../types/user/leaveManagmentType";

//Add Leave And Update Leave
export const addUserLeaveAction =
  (companyId, formingData, selectedFile) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_LEAVE_OF_USERS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const formdata = new FormData();
      // console.log(formingData);
      formdata.append("attachment", selectedFile);
      formdata.append("userId", formingData.userId);
      formdata.append("leaveDays", formingData.leaveDays);
      formdata.append("leaveType", formingData.leaveType);
      formdata.append("startTime", formingData.startTime);
      formdata.append("endTime", formingData.endTime);
      formdata.append("notes", formingData.notes);
      if (formingData?.leaveTypeId) {
        formdata.append("leaveTypeId", formingData.leaveTypeId);
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/leave/create`,
        formdata,
        config
      );
      dispatch({
        type: ADD_LEAVE_OF_USERS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADD_LEAVE_OF_USERS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Delete Leave
export const deleteLeaveAction =
  (id, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: DELETE_LEAVE_OF_USERS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/leave/delete`,
        { id },
        config
      );
      // console.log(data?.data?.company);
      dispatch({
        type: DELETE_LEAVE_OF_USERS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: DELETE_LEAVE_OF_USERS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get Leave By userId
export const GetLeavesByUsersAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_LEAVE_OF_USERS_BY_ID_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/leave/`,
        config
      );
      // console.log(data?.data?.company);
      dispatch({
        type: GET_LEAVE_OF_USERS_BY_ID_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: GET_LEAVE_OF_USERS_BY_ID_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get Leave By Company
export const GetLeavesByCompanyAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_LEAVE_OF_COMPANY_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/leave/all/company`,
      config
    );
    // console.log(data?.data?.company);
    dispatch({
      type: GET_LEAVE_OF_COMPANY_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: GET_LEAVE_OF_COMPANY_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Get Leave Setting
export const GetLeavesSettingByUsersAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_LEAVE_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/leave/setting`,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: GET_LEAVE_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: GET_LEAVE_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Leave Approval
export const AddLeaveApprovalByManagerAction =
  (userId, formData, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_LEAVE_OF_USERS_APPROVE_REQUEST,
      });
      const {
        getAllCompanySettingList,
        sharedLogin: { sharedUserInfo },
      } = getState();
      const { getCompanyInfo } = getAllCompanySettingList;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let userType = "";
      if (sharedUserInfo?.payload) {
        userType = sharedUserInfo?.payload?.type;
      } else {
        userType = sharedUserInfo?.type;
      }
      let modules;
      if (sharedUserInfo?.payload?.company) {
        modules =
          sharedUserInfo?.payload?.company?.modules.length > 0
            ? sharedUserInfo?.payload?.company?.modules
            : [];
      } else {
        modules =
          sharedUserInfo?.empCompanies[0]?.companyId?.modules.length > 0
            ? sharedUserInfo?.empCompanies[0]?.companyId?.modules
            : [];
      }
      let data;
      if (
        !modules.includes("leave_stages") &&
        !getCompanyInfo?.leaveStagesToggle
      ) {
        const { data: data2 } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/leave/create/approve/${userId}/`,
          formData,
          config
        );
        data = data2;
      } else {
        const { data: data2 } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/leave/stage/approve`,
          formData,
          config
        );
        data = data2;
      }
      // const { data } =
      // const { data } = await axios.post(
      //   `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/leave/create/approve/${userId}/`,
      //   formData,
      //   config
      // );
      // console.log(data?.data?.company);
      dispatch({
        type: ADD_LEAVE_OF_USERS_APPROVE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADD_LEAVE_OF_USERS_APPROVE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Leave Reject
export const AddLeaveRejectByManagerAction =
  (formData, userId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_LEAVE_OF_USERS_REJECT_REQUEST,
      });
      const {
        getAllCompanySettingList,
        sharedLogin: { sharedUserInfo },
      } = getState();
      const { getCompanyInfo } = getAllCompanySettingList;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let userType = "";
      if (sharedUserInfo?.payload) {
        userType = sharedUserInfo?.payload?.type;
      } else {
        userType = sharedUserInfo?.type;
      }
      let modules;
      if (sharedUserInfo?.payload?.company) {
        modules =
          sharedUserInfo?.payload?.company?.modules.length > 0
            ? sharedUserInfo?.payload?.company?.modules
            : [];
      } else {
        modules =
          sharedUserInfo?.empCompanies[0]?.companyId?.modules.length > 0
            ? sharedUserInfo?.empCompanies[0]?.companyId?.modules
            : [];
      }
      let data;
      if (
        !modules.includes("leave_stages") &&
        !getCompanyInfo?.leaveStagesToggle
      ) {
        const { data: data2 } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/leave/create/reject/${userId}/`,
          formData,
          config
        );
        data = data2;
      } else {
        const { data: data2 } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/leave/stage/reject`,
          formData,
          config
        );
        data = data2;
      }
      // console.log(data?.data?.company);
      dispatch({
        type: ADD_LEAVE_OF_USERS_REJECT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADD_LEAVE_OF_USERS_REJECT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
